import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ClientDepartmentForm } from "./ClientDepartmentForm";
import { ClientDepartmentItem } from "./ClientDepartmentItem";
import { getClientDepartmentsByAccountPartyIdAsync, resetSelectedRecordObjectInState, DeleteSelectedAccountClientDepartmentAsync } from "./ClientDepartmentSlice";
import OffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useLocation } from "react-router-dom";


export const ClientDepartment = () => {
    //let AccountPartyId : number
    //AccountPartyId=42599
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const AccountPartyId = params.get('AccountPartyId');
    const dispatch = useAppDispatch();
    const { clientDepartmentList, isReload, selectedRecord } = useAppSelector((state) => state.clientDepartment)

    useEffect(() => {
        if (isReload) {
            dispatch(getClientDepartmentsByAccountPartyIdAsync(AccountPartyId));
        }
    }, [isReload])
    useEffect(() => {
        dispatch(getClientDepartmentsByAccountPartyIdAsync(AccountPartyId));

    }, [dispatch])
    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState())
    }
    const generalObject = {
        "name": (Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add') + " Client Department",
        "width": "800px",
        "componentName": < ClientDepartmentForm AccountPartyId={AccountPartyId} />
    }
    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(DeleteSelectedAccountClientDepartmentAsync(clientDepartmentList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Client Contact delete Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                            // console.log('onDeleteClick-DeleteSelectedAccountEmployeeTypeAsync-originalPromiseResult', originalPromiseResult);
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                            //console.log('onDeleteClick-DeleteSelectedAccountEmployeeTypeAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });

    }
    return (
        <>
            <div className="card card-custom">
                <div className="card-header">
                    <h3 className="card-title">Client Department</h3>
                    <div className="card-toolbar">
                        <a id="kt_OffCanvas"
                            className='btn btn-sm btn-light-primary'
                            style={{ marginRight: '2px', display: clientDepartmentList.every((item: any) => item.isSelected === 0) ? 'none' : 'none' }}
                            onClick={handleOnClickEvent}>
                            <KTIcon iconName='exit-up' className='fs-3' />{`Export`}
                        </a>
                        <a id="kt_OffCanvas"
                            className='btn btn-sm btn-light-primary'
                            style={{ marginRight: '2px', display: clientDepartmentList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            onClick={handleOnClickEvent}>
                            <KTIcon iconName='plus' className='fs-3' />{`Add Client Department`}
                        </a>
                        <div className="fw-bold me-5" style={{ marginRight: '2px', display: clientDepartmentList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                            <span className="me-2" data-kt-user-table-select="selected_count">{clientDepartmentList.filter((item: any) => item.isSelected === 1).length}</span> Selected
                        </div>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                            style={{ marginRight: '2px', display: clientDepartmentList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                        >
                            Delete Selected
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <ClientDepartmentItem clientDepartmentList={clientDepartmentList}  AccountPartyId={AccountPartyId} />
                    </div>
                </div>
            </div>
            <OffCanvas obj={generalObject} />
        </>
    )


}